import { render, staticRenderFns } from "./google-ads-customer-dialog-app.vue?vue&type=template&id=3d57243c"
import script from "./google-ads-customer-dialog-app.vue?vue&type=script&lang=js"
export * from "./google-ads-customer-dialog-app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports